import { parseStringToBoolean, twClassMerge } from '@healthhub/react-ui';
import { Skeleton } from 'antd';

import { MaxWidthContainer } from '@shared/components';
import { DEROM_ENABLED } from '@shared/constants/systemSettingsKey';
import { useCurrentUserV2 } from '@shared/hooks/useCurrentUserV2';
import useIsAuthenticated from '@shared/hooks/useIsAuthenticated';
import { useSystemSettingsValue } from '@shared/hooks/useSystemSettingsValue';
import { useGetProfileEligibilityHealthPlanQuery } from '@shared/services/profileEligibility';

import DeromBanner from './DeromBanner';
import HsgBanner from './HsgBanner';

const Banner = () => {
  const { isAuthenticated } = useIsAuthenticated();

  const { isLoading: isLoadingUserProfile, userProfile } = useCurrentUserV2({ isPatientMasterInfoRequired: true });
  const { isLoading: isGetPEHealthplanLoading, data: healthPlanData } = useGetProfileEligibilityHealthPlanQuery(
    undefined,
    { skip: !isAuthenticated }
  );

  const { getValue } = useSystemSettingsValue([DEROM_ENABLED]);

  const isDeromEnabled = parseStringToBoolean(getValue(DEROM_ENABLED));

  const hasHealthPlan = healthPlanData?.HasHealthPlan ?? false;
  const isForeigner = !!userProfile?.IsForeigner;

  return (
    <div className="flex w-full justify-center px-3 pb-10 md:px-8 lg:px-18">
      <MaxWidthContainer>
        {isLoadingUserProfile || isGetPEHealthplanLoading ? (
          <Skeleton.Button active className="h-80 w-full" />
        ) : (
          <div
            className={twClassMerge(
              'grid grid-cols-1 gap-6',
              !isForeigner && isDeromEnabled && 'lg:auto-rows-fr lg:grid-cols-2'
            )}
          >
            {!isForeigner && <HsgBanner hasHealthPlan={hasHealthPlan} isDeromActive={isDeromEnabled} />}
            {!!isDeromEnabled && <DeromBanner isForeigner={isForeigner} />}
          </div>
        )}
      </MaxWidthContainer>
    </div>
  );
};

export default Banner;
